import { IDVGItemDTO, IGenericDTO } from "coreframetypings/dto";
import { IReadOnlyPrinterStatic } from '#/DefaultViewExtensionInterfaces';
import NavigationHelper from '@/Management/NavigationHelper';
import SimpleLinkBuilder from '@/Builder/SimpleLinkBuilder';
import { staticImplements } from '@/Components/@Decorator/StaticImplementsDecorator';
import Utilities from '@/Utility/Utilities';

@staticImplements<IReadOnlyPrinterStatic>()
export default class UrlLinkPrinter {

    public static print(item: IDVGItemDTO, value: string, row: IGenericDTO): HTMLElement {
        return new SimpleLinkBuilder()
            .withCaption(value)
            .withOnClick(() => {
                NavigationHelper.openWebPage(value, "_blank");
            })
            .buildAndGetElement();
    }

    public static isRelevant(item: IDVGItemDTO, value: string, row: IGenericDTO): boolean {
        return Utilities.isUrl(value);
    }

    public static createToolTip(item: IDVGItemDTO, value: string, row: IGenericDTO): string {
        return value;
    }
}